import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {SchemaRendererComponent} from '../../../workflow/renderer/schema-renderer/schema-renderer.component';
import {FormRenderConfig} from '../form-schema-renderer.component';

@Component({
	selector: 'app-card-style-renderer',
	templateUrl: './card-style-renderer.component.html',
	styleUrls: ['./card-style-renderer.component.scss']
})
export class CardStyleRendererComponent extends SchemaRendererComponent implements OnInit, OnChanges {

	@Input() formConfig: FormRenderConfig;
	@Input() schemaKey: string;
	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	constructor() {
		super();
	}

	ngOnInit(): void {}

	get renderer(): string {
		let type = 'string';
		if (typeof this.schema?.type === 'string') {
			type = this.schema?.type as string;
		}
		if (type === 'string' && this.schema?.format === 'date') {
			return 'date';
		}
		if (this.schema?.enum) {
			return 'enum';
		}
		return type;
	}

	parseReadOnly(formConfig: FormRenderConfig): FormRenderConfig {
		const result = Object.assign({}, formConfig);
		result.viewOnly ||= this.schema?.readOnly;
		return result;
	}

	setValid(input: unknown): void {
		this.valid.emit(!!input || !this.required);
	}
}
